export default __webpack_public_path__ + "static/base-lite-7-3beace84e3699b77a146085f667c0102.jpg";